import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { normalizeEvent } from 'ember-jquery-legacy';
import { closestAncestorWithId } from '@square/sq-ember-eventstream/utils/dom';

// In the case of Ember engines it is possible for usages of this component
// to be nested. To avoid changing any behavior of the click event while also
// preventing this component from tracking a single click more than once
// we store processed events in a map.
const processedEvents = new WeakMap();

export default Component.extend({
  eventstream: service(),

  metadata: null,

  // This action is triggered by all clicks within this component
  // in order to ensure that all clicks are tracked by Eventstream.
  click(event) {
    event = normalizeEvent(event);

    if (processedEvents.has(event)) {
      return;
    }

    const element = event.target;
    const ancestor = closestAncestorWithId(element);

    this.get('eventstream').trackPageClick(
      Object.assign(
        {
          elementIdentifier: ancestor ? ancestor.id : '',
          elementTitle: element.title,
          elementType: element.tagName.toLowerCase(),
        },
        this.get('metadata')
      )
    );

    processedEvents.set(event, 1);
  },
});
